import ButtonText from '@/components/ui/Typo/ButtonText'

interface RowProps {
  title: string
  text: string
  withoutBorder?: boolean
}

const TextRow: React.FC<RowProps> = ({ text, title, withoutBorder }) => {
  return (
    <div className="small:pl-4 small:pr-0 pr-3 pl-3 cursor-pointer hover:bg-gray-100 transition-colors">
      <div
        className={`py-4 flex items-center small:justify-start justify-between ${
          withoutBorder ? '' : 'border-b border-gray-300'
        }`}
      >
        <ButtonText
          size="big"
          color="text-gray3"
          weight="font-normal"
          className="small:w-[180px] small:mr-8 mr-4"
        >
          {title}
        </ButtonText>
        <ButtonText size="big" color="text-dark">
          {text}
        </ButtonText>
      </div>
    </div>
  )
}

export default TextRow
